import { z } from "zod";
import { subCategoryResultSchema } from "@/schema/console/evaluation-reports/SubCategoryResult";

export const mainCategoryResultSchema = z.object({
  id: z.number(),
  content: z.string(),
  score: z.number().nullable(),
  sub_category_results: z.array(
    subCategoryResultSchema
  ),
});

export type MainCategoryResult = z.infer<typeof mainCategoryResultSchema>;
